import { useState } from '#app'

export function useProgressNotificationsMenu() {
  const isOpen = useState<boolean>('progress-notifications-menu-open', () => false)

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  function toggle(value?: boolean) {
    isOpen.value = value ?? !isOpen.value
  }

  return {
    isOpen,
    open,
    close,
    toggle,
  }
}
